module.exports = __webpack_public_path__ + "static/media/Ciutadella-Regular.d343acf7.woff";